<template>
  <layout-modal
    :classes="classes"
    :closable="false"
    position="middle-center" 
    :visible="visible">

    <div class="catalog-table__body">
      <div class="catalog-table__content">
        <h1 class="catalog-table__title">{{ $t('sayl-oat.table_title') }}</h1>
        <p class="catalog-table__description">{{ $t('sayl-oat.table_description') }}</p>

        <!-- <forms-input 
          autofocus
          class="catalog-table__field"
          type="number"
          :min="1"
          :max="42"
          :placeholder="$t('sayl-oat.placeholder_table_number')"
          v-model="value">{{$t('sayl-oat.table_number_entry')}}</forms-input> -->

        <forms-select 
          :placeholder="$t('sayl-oat.placeholder_table_number')"
          :options="tablesList"
          v-model="value"
          :errors="error"
          @change="error = []"
        >{{$t('sayl-oat.table_number_entry')}}</forms-select>

        <forms-input 
          class="catalog-table__field"
          type="email"
          :placeholder="$t('sayl-oat.placeholder_email')"
          v-model="email">{{$t('sayl-oat.email')}}</forms-input>
      </div>

      <figure class="catalog-table__illustration">
        <img
          class="catalog-table__image" 
          src="/statics/images/table.jpg" alt="table illustration">
      </figure>
    </div>

    <footer class="catalog-table__footer">
      <actions-button 
        appearance="primary"
        @click="onConfirm">{{$t('sayl-oat.action_confirm')}}</actions-button>
    </footer>

  </layout-modal>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex' 
import LayoutModal from '@/components/layouts/modal'

export default {
  name: 'CatalogTable',
  
  components: {
    LayoutModal
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data(){
    return {
      value: null,
      email: null,
      error: [],
    }
  },

  computed: {
    ...mapState({
      user: state => state['sayl-oat.user'].user,
      tables: state => state['sayl-oat'].tables,
    }),

    classes(){
      return {
        'catalog-table': true
      }
    },

    tablesList() {
      let ret = [];

      this.tables && this.tables.forEach(t => {
        ret.push({
          label: t.name,
          value: t.id
        });
      });

      return ret;
    },
  },

  methods: {
    ...mapActions({
      updateUser: 'sayl-oat.user/update'
    }),

    ...mapMutations({
      setTableNumber: 'setTableNumber'
    }),

    onConfirm(){
      this.error = [];

      if(['', null, undefined].includes(this.value)){
        this.error = [this.$t('sayl-oat.table_error')];
      } else if(this.email !== null) {
        const user = { email: this.email };

        this.updateUser(user).then(() => { 
          this.setTableNumber(this.value);
          this.$emit('close');
        }).catch((error) => {
          console.error(error)
        });
      } else {
        this.setTableNumber(this.value);
        this.$emit('close');
      }
    }
  }
}
</script>
